import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';

import scss from './MeetConcierge.module.scss';
import { MOBILE_MID_BREAKPOINT } from '@helper/constants';
import { Link } from 'react-router-dom';

interface IMeetConciergeProps {
    isOnDashboard: boolean;
    openPrefModal: () => void;
}

const MeetConcierge: React.FC<IMeetConciergeProps> = ({ isOnDashboard, openPrefModal }) => {
    const [isMobile, setIsMobile] = useState<boolean>(window.matchMedia(MOBILE_MID_BREAKPOINT).matches);
    const [showFullContent, setShowFullContent] = useState<boolean>(true);
    
    useEffect(() => {
        const mediaQuery = window.matchMedia(MOBILE_MID_BREAKPOINT);
        const handleResize = () => {
            setIsMobile(mediaQuery.matches);
            if (mediaQuery.matches) {
                setShowFullContent(false);
            }
        };
        
        handleResize();
        mediaQuery.addEventListener("change", handleResize);

        return () => {
            mediaQuery.removeEventListener("change", handleResize);
        };
    }, []);

    const toggleContent = () => {
        setShowFullContent(prev => !prev);
    }
    
    return (
        <div>
            <h1 className={'text-center'}>Meet Darcy</h1>
            <div className={scss.videoContainer}>
                <iframe className={scss.video}
                    src={'https://player.vimeo.com/video/939441460?h=78ef033175&title=0&byline=0&portrait=0'}
                    allow={'autoplay; fullscreen; picture-in-picture'}
                    allowFullScreen>
                </iframe>
            </div>
            <div className={scss.infoContainer}>
                <div className={scss.aboutConcierge}>
                    <div className={scss.columnHeading}>About Darcy</div>
                    <p>
                        Darcy is a passionate and creative wedding planner known for her 
                        ability to bring each couple's unique vision to life. With over 
                        a decade of experience in the industry, she has a keen eye for
                        {!isMobile || showFullContent ? ' detail and a knack for organising seamless events and negotiating supplier upgrades and discounts.' : '...'}
                    </p>
                </div>
                {!isMobile || showFullContent ? <div className={scss.examples}>
                    <div className={scss.columnHeading}>Darcy can help with</div>
                    <ul className={scss.checkList}>
                        <li>Venue recommendations</li>
                        <li>Schedule venue tours</li>
                        <li>Wedding planning support</li>
                        <li>Budgeting assistance</li>
                        <li>Package discounts</li>
                        <li>Destination Weddings</li>
                    </ul>
                </div> : null}
            </div>
            {isMobile && (
                <div className={scss.readMoreButton} onClick={toggleContent}>
                    {showFullContent ? "Read Less" : "Read More"}
                </div>
            )}
            <Button onClick={openPrefModal} variant={'primary'} className={`w-100 d-flex ${isOnDashboard ? 'd-none d-sm-block' : ''}`}>Message Darcy</Button>
            {isOnDashboard && <Link to='/concierge-preferences' className={`${scss.inboxButton} d-flex d-sm-none`}>
                <Button onClick={openPrefModal} variant={'primary'} className={'w-100'}>Message Darcy</Button>
            </Link>}
        </div>
    )
}

export default React.memo(MeetConcierge);
